const accordionItems = document.querySelectorAll('.btnGlobal__btnArea');

accordionItems.forEach((item) => {
  const header = item.querySelector('.btnGlobal__clickArea');
  const content = item.querySelector('.btnGlobal__selectArea');
  const btns = item.querySelectorAll('.btnGlobal__list'); // すべてのリスト項目を取得

  header.addEventListener('click', () => {
    if (content.getAttribute('aria-hidden') === 'true') {
      content.classList.remove('is-close');
      content.classList.add('is-open');
      content.setAttribute('aria-hidden', 'false');
    } else {
      content.classList.remove('is-open');
      content.classList.add('is-close');
      content.setAttribute('aria-hidden', 'true');
    }
  });

  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      content.classList.remove('is-open');
      content.classList.add('is-close');
      content.setAttribute('aria-hidden', 'true');
    });
  });
});
